import { Directive, OnInit, inject, input } from '@angular/core';

import { injectCurrentTheme } from '@frontend/sports/common/ui/shared';
import { DsSwitch } from '@frontend/ui/switch';

import { SwitchInverse, SwitchVariant } from './types';

@Directive({
    selector: '[msThemedSwitch]',
    standalone: true,
})
export class SportsThemedSwitch implements OnInit {
    themedVariant = input<SwitchVariant | undefined>(undefined);
    themeInverse = input<SwitchInverse | undefined>(undefined);

    currentTheme = injectCurrentTheme();
    switch: DsSwitch = inject(DsSwitch, {
        self: true,
    });

    ngOnInit(): void {
        const variant = this.themedVariant()?.[this.currentTheme];
        if (variant) {
            this.switch.variant = variant;
        }
        const inverse = this.themeInverse()?.[this.currentTheme];
        if (inverse) {
            this.switch.inverse = inverse.isInverse;
        }
    }
}
